export default "__VITE_ASSET__0a5c999b__"